import { Injectable } from '@angular/core';
import { SafetyClassInstitution, SafetyModel } from '@ups/xplat/api/dto';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';
import { parseData } from '@ups/xplat/utils';

const GET_TRAINING_BY_HRREF = '/api/hret/training/{:ID}';
// const GET_CERTIFICATION_SKILLTESTERS: string = '/api/hret/skilltesters';
const GET_CERTIFICATION_SKILLTESTERS = '/api/hrrs/skilltesters';
const PUT_SAFETY_ITEM = '/api/hret/training'; // create, HRREF inside DTO
const PUT_SAFETY_ITEMS = '/api/hret/trainings';
const POST_SAFETY_ITEM = '/api/hret/training'; // update, KeyID inside DTO
const GET_SAFETY_CLASSES = '/api/codelist/training/safety/classdesc';
const GET_SAFETY_INSTITUTIONS = '/api/codelist/training/institutions';

interface DataEnvelope<T> {
  Data: T;
}

@Injectable({ providedIn: 'root' })
export class HRRTService {
  http: HttpClient;

  constructor(private httpFactory: MyHttpClientFactory) {
    this.http = httpFactory.createHttpClient(environment.urls.viewpointAPI);
  }

  public getTrainingById(id: string): Promise<SafetyModel[]> {
    const url = GET_TRAINING_BY_HRREF.split('{:ID}').join(id);

    return this.http.get<SafetyModel[]>(url).toPromise().then(parseData);
  }

  public getCertificationSkillTesters(): Promise<DataEnvelope<unknown[]>> {
    const url = GET_CERTIFICATION_SKILLTESTERS;

    return this.http
      .get<DataEnvelope<unknown[]>>(url)
      .toPromise()
      .then(parseData);

    // NOTE: all our fnc. returns a promise, so why we do return here values instead? violation of using same behaviour !
  }

  public searchCertificationSkillTesters(
    term: string,
    top: number = 10
  ): Promise<DataEnvelope<unknown[]>> {
    const url =
      GET_CERTIFICATION_SKILLTESTERS +
      '/?search=' +
      encodeURI(term) +
      '&top=' +
      top;
    return this.http
      .get<DataEnvelope<unknown[]>>(url)
      .toPromise()
      .then(parseData);
  }

  public createSafetyItem(item: SafetyModel): Promise<SafetyModel> {
    return this.http
      .put<SafetyModel>(PUT_SAFETY_ITEM, item)
      .toPromise()
      .then(parseData);
  }

  public createSafetyItems(items: SafetyModel[]): Observable<unknown> {
    return this.http.put(PUT_SAFETY_ITEMS, items);
  }

  public updateSafetyItem(item: SafetyModel): Promise<SafetyModel> {
    return this.http
      .post<SafetyModel>(POST_SAFETY_ITEM, item)
      .toPromise()
      .then(parseData);
  }

  public getSafetyInstitutionNames(): Promise<string[]> {
    const url = GET_SAFETY_INSTITUTIONS;

    return this.http.get<string[]>(url).toPromise().then(parseData);
  }

  public getSafetyClassNames(): Promise<SafetyClassInstitution[]> {
    const url = GET_SAFETY_CLASSES;

    return this.http
      .get<SafetyClassInstitution[]>(url)
      .toPromise()
      .then(parseData);
  }

  public searchSafetyClassNames(
    term: string,
    top: number = 10
  ): Promise<unknown> {
    const url =
      GET_SAFETY_CLASSES + '/?search=' + encodeURI(term) + '&top=' + top;
    return this.http.get(url).toPromise().then(parseData);
  }
}
